<div class="bcg p-4">
  <div class="row my-3">
    <div class="col-lg-7 col-sm-7 col-md-7">
      <p class="nav_link_cat ms-1 mb-3 flex_row">
        <span class="clickable" (click)="gotoDashboard()">Dashboard</span>
        <span [style.font-weight]="'bold'"> >> </span>
        <span class="clickable" (click)="gotoListing()">User Management</span>
        <span [style.font-weight]="'bold'"> >> </span>
        <span *ngIf="!editMode">Add New User</span>
        <span *ngIf="editMode">Edit User</span>
      </p>
    </div>
  </div>

  <div class="card card_outLine mt-3">
    <div class="card-body">
      <div class="row">
        <div *ngIf="editMode" class="col-lg-6 col-sm-6 col-md-6">
          <h5 class="title_five">Edit User</h5>
          <p class="card-text text_p">Edit your User details here!</p>
        </div>
        <div *ngIf="!editMode" class="col-lg-6 col-sm-6 col-md-6">
          <h5 class="title_five">Add New User</h5>
          <p class="card-text text_p">Create new User here!</p>
        </div>
        <!-- <div *ngIf="!editMode" class="col-lg-6 col-sm-6 col-md-6 text-right">
          <p-button class="ms-2" label="Bulk Upload" styleClass="p-button-sm-outline"></p-button>
        </div> -->
      </div>
    </div>
  </div>
  <div class="card card_outLine mt-3">
    <div class="card-body">
      <div class="row">
        <div *ngIf="!editMode" class="row mt-2 form_inputFields">
          <div class="col-11 m-2">
            <h5 class="title_five">User Details</h5>
            <form [formGroup]="addUserForm">
              <div formArrayName="addnewUserDetails">
                <section
                  *ngFor="
                    let details of userDetailsArray().controls;
                    let i = index
                  "
                  [formGroupName]="i"
                >
                  <div class="form_outline_sty">
                    <div class="row">
                      <div class="col-lg-4 col-sm-4 col-md-4">
                        <span class="form_field">First Name</span
                        ><span class="color_red">*</span>
                        <input
                          class="form-control edit_input"
                          formControlName="firstName"
                          placeholder="Enter First Name"
                          pInputText
                          type="text"
                          onkeypress="return (event.charCode >= 65 && event.charCode <= 90)
                          || (event.charCode >= 97 && event.charCode <= 122)
                          || (event.charCode >= 48 && event.charCode <= 57)
                          || event.charCode == 32"
                          (paste)="handlePasteEvent($event)"
                        />
                        <span
                          class="p-error"
                          style="font-size: 0.5rem"
                          *ngIf="
                            submitted &&
                            userDetailsArray()
                              .at(i)
                              .get('firstName')
                              ?.hasError('required')
                          "
                          >*Maximum of 100 characters
                        </span>
                        <span
                          class="p-error"
                          style="font-size: 0.5rem"
                          *ngIf="
                            submitted &&
                            userDetailsArray()
                              .at(i)
                              .get('firstName')
                              ?.hasError('notOnlyNumbers')
                          "
                          >*Cannot be only numbers</span
                        >
                        <span
                          class="p-error"
                          style="font-size: 0.5rem"
                          *ngIf="
                            submitted &&
                            userDetailsArray()
                              .at(i)
                              .get('firstName')
                              ?.hasError('noLeadingSpaces')
                          "
                          >*Cannot start with spaces</span
                        >
                      </div>
                      <div class="col-lg-4 col-sm-4 col-md-4">
                        <span class="form_field">Last Name</span
                        ><span class="color_red">*</span>
                        <input
                          class="form-control edit_input"
                          formControlName="lastName"
                          placeholder="Enter Last Name"
                          pInputText
                          type="text"
                          onkeypress="return (event.charCode >= 65 && event.charCode <= 90)
                          || (event.charCode >= 97 && event.charCode <= 122)
                          || (event.charCode >= 48 && event.charCode <= 57)
                          || event.charCode == 32"
                          (paste)="handlePasteEvent($event)"
                        />
                        <span
                          class="p-error"
                          style="font-size: 0.5rem"
                          *ngIf="
                            submitted &&
                            userDetailsArray()
                              .at(i)
                              .get('lastName')
                              ?.hasError('required')
                          "
                          >*Maximum of 100 characters
                        </span>
                        <span
                          class="p-error"
                          style="font-size: 0.5rem"
                          *ngIf="
                            submitted &&
                            userDetailsArray()
                              .at(i)
                              .get('lastName')
                              ?.hasError('notOnlyNumbers')
                          "
                          >*Cannot be only numbers</span
                        >
                        <span
                          class="p-error"
                          style="font-size: 0.5rem"
                          *ngIf="
                            submitted &&
                            userDetailsArray()
                              .at(i)
                              .get('lastName')
                              ?.hasError('noLeadingSpaces')
                          "
                          >*Cannot start with spaces</span
                        >
                      </div>

                      <div class="col-lg-3 col-sm-3 col-md-3">
                        <span class="form_field">Email</span
                        ><span class="color_red">*</span>
                        <input
                          class="form-control edit_input"
                          formControlName="email"
                          placeholder="Enter Email"
                          pInputText
                          type="text"
                        />
                        <span
                          class="p-error"
                          style="font-size: 0.5rem"
                          *ngIf="
                            submitted &&
                            userDetailsArray()
                              .at(i)
                              .get('email')
                              ?.hasError('required')
                          "
                          >*Enter a Email
                        </span>
                      </div>

                      <div
                        *ngIf="i != 0"
                        style="padding-top: 15px"
                        class="col-lg-1 col-sm-1 col-md-1 remove_btn"
                      >
                        <button
                          pButton
                          pRipple
                          type="button"
                          icon="pi pi-trash"
                          (click)="removeUser(i)"
                          class="p-button-sm"
                        ></button>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-lg-4 col-sm-4 col-md-4">
                        <span class="form_field">Mobile No</span
                        ><span class="color_red">*</span>
                        <input
                          class="form-control edit_input"
                          formControlName="contact"
                          placeholder="Enter contact"
                          pInputText
                          type="text"
                          (keypress)="numberOnlyForContact($event)"
                          [maxlength]="10"
                          [minlength]="10"
                        />
                        <span
                          class="p-error"
                          style="font-size: 0.5rem"
                          *ngIf="
                            submitted &&
                            userDetailsArray()
                              .at(i)
                              .get('contact')
                              ?.hasError('required')
                          "
                          >*Enter contact no.
                        </span>
                        <span
                          class="p-error"
                          style="font-size: 0.5rem"
                          *ngIf="
                            submitted &&
                            (userDetailsArray()
                              .at(i)
                              .get('contact')
                              ?.hasError('minlength') ||
                              userDetailsArray()
                                .at(i)
                                .get('contact')
                                ?.hasError('maxlength'))
                          "
                          >*Enter valid Contact Number (should contain 10
                          digits)
                        </span>
                      </div>
                      <div class="col-lg-4 col-sm-4 col-md-4">
                        <span class="form_field">Role</span
                        ><span class="color_red">*</span>
                        <div>
                          <app-dropdown
                            class="custom-dropdown text-left"
                            placeholder="Select Role"
                            [options]="roleType"
                            formControlName="role"
                          ></app-dropdown>
                        </div>
                        <span
                          class="p-error"
                          style="font-size: 0.5rem"
                          *ngIf="
                            submitted &&
                            userDetailsArray()
                              .at(i)
                              .get('role')
                              ?.hasError('required')
                          "
                          >*Select Role
                        </span>
                      </div>
                      <div class="col-lg-3 col-sm-3 col-md-3">
                        <span class="form_field">Status</span
                        ><span class="color_red">*</span>
                        <input
                          class="form-control edit_input"
                          formControlName="status"
                          placeholder="Enter Status"
                          pInputText
                          type="text"
                          [readOnly]="true"
                        />
                        <span
                          class="p-error"
                          style="font-size: 0.5rem"
                          *ngIf="
                            submitted &&
                            userDetailsArray()
                              .at(i)
                              .get('status')
                              ?.hasError('required')
                          "
                          >*Enter a Status
                        </span>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-lg-4 col-sm-4 col-md-4">
                        <span class="form_field">Account</span
                        ><span class="color_red">*</span>
                        <div>
                          <app-dropdown
                            [options]="accountUserData"
                            class="custom-dropdown"
                            placeholder="Select Account"
                            optionLabel="account_name"
                            [filter]="true"
                            filterBy="account_name"
                            formControlName="account"
                            (onChange)="onSelectedAccountData($event ,i)"
                            appendTo="body"
                          ></app-dropdown>
                        </div>
                        <span
                          class="p-error"
                          style="font-size: 0.5rem"
                          *ngIf="
                            submitted &&
                            userDetailsArray()
                              .at(i)
                              .get('account')
                              ?.hasError('required')
                          "
                          >*Select Branch
                        </span>
                      </div>
                      <div class="col-lg-4 col-sm-4 col-md-4">
                        <span class="form_field">Branch</span
                        ><span class="color_red">*</span>
                        <div class="overlay">
                          <app-multiselect-dropdown
                            class="custom-dropdown text-left"
                            placeholder="Select Branch"
                            [options]="branchData[i]"
                            formControlName="branch"
                            optionLabel="name"
                            optionValue="id"
                          ></app-multiselect-dropdown>
                        </div>
                        <span
                          class="p-error"
                          style="font-size: 0.5rem"
                          *ngIf="
                            submitted &&
                            userDetailsArray()
                              .at(i)
                              .get('branch')
                              ?.hasError('required')
                          "
                          >*Select Branch
                        </span>
                      </div>
                    </div>

                    <div class="row mt-2">
                      <div class="col-lg-4 col-sm-4 col-md-4">
                        <span class="form_field">Password</span
                        ><span class="color_red">*</span>
                        <input
                          class="form-control edit_input"
                          formControlName="password"
                          placeholder="Enter Password"
                          pInputText
                          type="password"
                          (change)="onPasswordChange(i)"
                        />
                        <span
                          class="p-error"
                          style="font-size: 0.5rem"
                          *ngIf="
                            submitted &&
                            userDetailsArray()
                              .at(i)
                              .get('password')
                              ?.hasError('required')
                          "
                          >*Maximum of 100 characters
                        </span>
                        <span
                          class="p-error"
                          style="font-size: 0.5rem"
                          *ngIf="
                            submitted &&
                            userDetailsArray()
                              .at(i)
                              .get('password')
                              ?.hasError('pattern')
                          "
                          >*Must contain at least one number,one special
                          character, one uppercase and lowercase letter, and at
                          least 8 or more characters</span
                        >
                      </div>

                      <div class="col-lg-4 col-sm-4 col-md-4">
                        <span class="form_field">Confirm Password</span
                        ><span class="color_red">*</span>
                        <input
                          class="form-control edit_input"
                          formControlName="cpassword"
                          placeholder="Enter Confirm Password"
                          pInputText
                          type="password"
                          (change)="onPasswordChange(i)"
                        />
                        <span
                          class="p-error"
                          style="font-size: 0.5rem"
                          *ngIf="
                            submitted &&
                            userDetailsArray()
                              .at(i)
                              .get('cpassword')
                              ?.hasError('required')
                          "
                          >*Enter a Confirm Password
                        </span>
                        <span
                          class="p-error"
                          style="font-size: 0.5rem"
                          *ngIf="
                            submitted &&
                            userDetailsArray()
                              .at(i)
                              .get('cpassword')
                              ?.hasError('mismatch')
                          "
                          >*Both passwords must match</span
                        >
                      </div>

                    <!-- <div class="col-lg-3 col-sm-3 col-md-3">
                      <span class="form_field">Is API user</span><span class="color_red">*</span>
                      
                      <div class="d-flex flex-row gap-4 mt-2">
                        
                         <div class="d-flex align-items-center">
                          <p-radioButton 
                            name="is_api_user" 
                            [value]="false" 
                            formControlName="is_api_user"
                            inputId="api_no">
                          </p-radioButton>
                          <label for="api_no" class="ms-2 mb-0 cursor-pointer">No</label>
                        </div>

                        <div class="d-flex align-items-center">
                          <p-radioButton 
                            name="is_api_user" 
                            [value]="true" 
                            formControlName="is_api_user"
                            inputId="api_yes">
                          </p-radioButton>
                          <label for="api_yes" class="ms-2 mb-0 cursor-pointer">Yes</label>
                        </div>
                      </div>

                      <small 
                        class="p-error block mt-1" 
                        style="font-size: 0.5rem"
                        *ngIf="submitted && userDetailsArray().at(i).get('is_api_user')?.invalid">
                        *Selection required
                      </small>
                    </div> -->

                    </div>
                  </div>
                </section>
              </div>
              <div class="custom_button me-2 mt-3" style="margin-left: 7px">
                <p-button
                  icon="pi pi-plus"
                  label="Add user"
                  (click)="addnewUserDetail()"
                  styleClass="p-button-sm-outline"
                ></p-button>
              </div>
            </form>
          </div>
          <div
            class="text-right custom_button me-2 mt-3"
            style="margin-left: 7px"
          >
            <p-button
              label="Back"
              [style]="{ width: '5rem' }"
              [routerLink]="['/doqfy/management/user-listing']"
              styleClass="p-button-sm"
            ></p-button>
            <p-button
              class="ms-2"
              [style]="{ width: '5rem' }"
              label="Save"
              (click)="saveuser()"
              styleClass="p-button-sm-outline"
            ></p-button>
          </div>
        </div>

        <div *ngIf="editMode" class="row mt-2 form_inputFields">
          <div class="col-12 px-3">
            <h5 class="title_five">Edit User Details</h5>
            <form [formGroup]="editUserForm">
              <div>
                <div class="form_outline_sty">
                  <div class="row g-3">
                    <div class="col-lg-4 col-sm-4 col-md-4">
                      <span class="form_field">First Name</span
                      ><span class="color_red">*</span>
                      <input
                        class="form-control edit_input"
                        formControlName="firstName"
                        placeholder="Enter First Name"
                        pInputText
                        type="text"
                      />
                      <span
                        class="p-error"
                        style="font-size: 0.5rem"
                        *ngIf="submitted && editUserForm.get('firstName')?.hasError('required')"
                        >*Maximum of 100 characters
                      </span>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-md-4">
                      <span class="form_field">Last Name</span
                      ><span class="color_red">*</span>
                      <input
                        class="form-control edit_input"
                        formControlName="lastName"
                        placeholder="Enter Last Name"
                        pInputText
                        type="text"
                      />
                      <span
                        class="p-error"
                        style="font-size: 0.5rem"
                        *ngIf="submitted && editUserForm.get('lastName')?.hasError('required')"
                        >*Maximum of 100 characters
                      </span>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-md-4">
                      <span class="form_field">Email</span
                      ><span class="color_red">*</span>
                      <input
                        class="form-control edit_input"
                        formControlName="email"
                        placeholder="Enter Email"
                        pInputText
                        type="text"
                      />
                      <span
                        class="p-error"
                        style="font-size: 0.5rem"
                        *ngIf="submitted && editUserForm.get('email')?.hasError('required')"
                        >*Enter a Email
                      </span>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-md-4">
                      <span class="form_field">Mobile No</span
                      ><span class="color_red">*</span>
                      <input
                        class="form-control edit_input"
                        formControlName="contact"
                        placeholder="Enter contact"
                        pInputText
                        type="text"
                        (keypress)="numberOnlyForContact($event)"
                        [maxlength]="10"
                        [minlength]="10"
                      />
                      <span
                        class="p-error"
                        style="font-size: 0.5rem"
                        *ngIf="submitted && editUserForm.get('contact')?.hasError('required')"
                        >*Enter a contact no.
                      </span>
                      <span
                        class="p-error"
                        style="font-size: 0.5rem"
                        *ngIf="submitted && (editUserForm.get('contact')?.hasError('minlength') || editUserForm.get('contact')?.hasError('maxlength'))"
                        >*Enter valid Contact Number (should contain 10 digits)
                      </span>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-md-4">
                      <span class="form_field">Role</span
                      ><span class="color_red">*</span>
                      <div class="overlay">
                        <app-dropdown
                          class="custom-dropdown text-left"
                          placeholder="Select Role"
                          [options]="roleType"
                          formControlName="role"
                          (onChange)="handleRoleSelection($event)"
                        ></app-dropdown>
                      </div>
                      <span
                        class="p-error"
                        style="font-size: 0.5rem"
                        *ngIf="submitted && editUserForm.get('role')?.hasError('required')"
                        >*Select Role
                      </span>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-md-4">
                      <span class="form_field">Status</span
                      ><span class="color_red">*</span>
                      <input
                        class="form-control edit_input grey_background"
                        formControlName="status"
                        placeholder="Enter Status"
                        pInputText
                        type="text"
                        [readOnly]="true"
                      />
                      <span
                        class="p-error"
                        style="font-size: 0.5rem"
                        *ngIf="submitted && editUserForm.get('status')?.hasError('required')"
                        >*Enter a Status
                      </span>
                    </div>
                  </div>

                  <div formArrayName="accountBranchArray" class="mt-3">
                    <div *ngFor="let accountBranch of accountBranchArray.controls; let i = index" [formGroupName]="i">
                      <div class="row g-3 mb-2">
                        <div class="col-lg-4 col-sm-4 col-md-4">
                          <span class="form_field">Account</span
                          ><span class="color_red">*</span>
                          <div class="overlay">
                            <app-dropdown
                              *ngIf="showRole"
                              [options]="accountUserData"
                              class="custom-dropdown"
                              placeholder="Select Account"
                              optionLabel="account_name"
                              [filter]="true"
                              filterBy="account_name"
                              optionValue="id"
                              formControlName="account"
                              (onChange)="onSelectedAccount($event, i)"
                            ></app-dropdown>
                            <app-dropdown
                              *ngIf="!showRole"
                              [options]="accountUserData"
                              class="custom-dropdown"
                              placeholder="Select Account"
                              optionLabel="account_name"
                              [filter]="true"
                              filterBy="account_name"
                              optionValue="account_id"
                              formControlName="account"
                              (onChange)="onSelectedAccount($event, i)"
                            ></app-dropdown>
                          </div>
                          <span
                            class="p-error"
                            style="font-size: 0.5rem"
                            *ngIf="submitted && editUserForm.get('account')?.hasError('required')"
                            >*Select Account
                          </span>
                        </div>
                        <div class="col-lg-4 col-sm-4 col-md-4">
                          <span class="form_field">Branch</span
                          ><span class="color_red">*</span>
                          <div class="overlay">
                            <app-multiselect-dropdown
                              class="custom-dropdown text-left"
                              placeholder="Select Branch"
                              [options]="branchData[i]"
                              formControlName="branch"
                              optionLabel="name"
                              optionValue="id"
                              [filter]="true"
                              filterBy="name"
                              appendTo="body"
                              (onChange)="handleBranchSelection($event)"
                            ></app-multiselect-dropdown>
                          </div>
                          <span
                            class="p-error"
                            style="font-size: 0.5rem"
                            *ngIf="submitted && editUserForm.get('branch')?.hasError('required')"
                            >*Select Branch
                          </span>
                        </div>
                        <div class="col-lg-1 col-sm-1 col-md-1 d-flex align-items-end pb-1">
                          <p-button
                            icon="pi pi-trash"
                            [style]="{ width: '2rem' }"
                            (click)="removeAccountBranch(i)"
                            styleClass="p-button-sm"
                          ></p-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mt-3 ps-1">
                    <p-button
                      icon="pi pi-plus"
                      label="Account"
                      (click)="addAccountBranch()"
                      styleClass="p-button-sm-outline"
                    ></p-button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="text-right custom_button px-3 mt-3">
            <p-button
              label="Back"
              [style]="{ width: '5rem' }"
              [routerLink]="['/doqfy/management/user-listing']"
              styleClass="p-button-sm"
            ></p-button>
            <p-button
              class="ms-2"
              [style]="{ width: '5rem' }"
              label="Save"
              (click)="edituser()"
              styleClass="p-button-sm-outline"
            ></p-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="toast_display_layer">
  <p-toast></p-toast>
</div>
